module.exports = __webpack_public_path__ + "img/inter_2.5ea6fd77.gif";